// Crew Settings Header - company avatar + tab bar (indigo theme, Figma design)
import React from 'react';
import { cn } from 'lib/utils';

// Tab definitions - visibility controlled by parent via visibleTabs
const ALL_TABS = [
  { id: 'account', label: 'Account' },
  { id: 'departments', label: 'Department management' },
  { id: 'users', label: 'User management' },
  { id: 'clients', label: 'All clients' },
];

const CrewSettingsHeader = ({ clientName, createdDate, activeTab, onTabChange, visibleTabs }) => {
  const tabs = ALL_TABS.filter((t) => visibleTabs.includes(t.id));

  return (
    <div className="tw-bg-white tw-border-b tw-border-gray-200 tw-px-6 tw-pt-6">
      {/* Company identity row */}
      <div className="tw-flex tw-items-center tw-gap-4 tw-mb-6">
        <div className="tw-w-14 tw-h-14 tw-rounded-full tw-bg-indigo-600 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0">
          <span className="tw-text-white tw-text-xl tw-font-bold tw-leading-none">
            {clientName ? clientName.charAt(0).toUpperCase() : '?'}
          </span>
        </div>
        <div>
          <h2 className="tw-text-lg tw-font-bold tw-text-gray-900 tw-m-0 tw-leading-tight">
            {clientName}
          </h2>
          {createdDate && (
            <p className="tw-text-xs tw-text-gray-400 tw-mt-0.5 tw-mb-0">
              Created: {createdDate}
            </p>
          )}
        </div>
      </div>

      {/* Tab bar */}
      <div className="tw-flex tw-items-center tw-gap-2 tw-pb-0">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              'tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-rounded-full tw-border-0 tw-cursor-pointer tw-transition-all tw-whitespace-nowrap',
              activeTab === tab.id
                ? 'tw-bg-indigo-600 tw-text-white'
                : 'tw-bg-transparent tw-text-indigo-600 hover:tw-bg-indigo-50'
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CrewSettingsHeader;
